import React, { FC } from 'react';
import { EquipmentAssignment } from '../../shared/types/equipmentAssignment';
import { getOrderStatus } from '../../core/helpers/translate';
import { StatusIcon } from '../statusIcon';

export const EquipmentOrderStatusIcon: FC<{a: EquipmentAssignment}> = ({ a }) => (
  <StatusIcon status={getOrderStatus(a)} />
);
